module.exports = __webpack_public_path__ + "img/create-orde1r.34d64736.jpg";